import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  gs,
  BoxC,
  BtnC,
  BtnTopC,
  GridC,
  MsgC,
  _cv_41___Ti,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as _cv_41___Ti from "./_cv_41___Ti";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(_cv_41___Ti.L, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                cdn: `_41r_31r1f=${_gUserz.crt._31rz?._fst}`
              }
            }),

            cr.c(_cv_41___Ti.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeS40Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
